import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { ModalStoreType } from '../../../store/ModalStore';
import { Modal } from 'antd';

interface AppConfirmProps {
  ModalStore?: ModalStoreType;
}

@inject('ModalStore')
@observer
export class AppConfirm extends React.Component<AppConfirmProps> {
  public render() {
    const { confirm } = this.props.ModalStore!;
    return (
      <Modal
        title={confirm.title}
        visible={confirm.isOpen}
        onOk={confirm.confirm}
        onCancel={confirm.cancel}
        okButtonDisabled={!confirm.withConfirm}
        cancelButtonDisabled={confirm.cancelDisabled}
      >
        <p>{confirm.content}</p>
      </Modal>
    );
  }
}
